import React, { useCallback, useState } from 'react'
import { isEmptyString } from '../../../../utils/string-utils'
import { IconButton, Tooltip } from '@mui/material'
import AccountsModal from './accounts-modal'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'

export interface ViewAccountsModalTriggerProps {
  strategyId: string
  strategyName: string
  isApiConnected: boolean
  accountsUrl: string | null
  controlExecuteCommandUrl: string | null
}

const AccountsModalTrigger: React.FC<ViewAccountsModalTriggerProps> = (props) => {
  const { strategyId, strategyName, isApiConnected, accountsUrl, controlExecuteCommandUrl } = props
  const isDisabled = !isApiConnected || isEmptyString(accountsUrl)

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  const openModal = useCallback(() => {
    setIsModalOpen(true)
  }, [])

  const closeModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  return (
    <>
      <AccountsModal
        open={isModalOpen}
        onClose={closeModal}
        strategyId={strategyId}
        title={`${strategyName} Accounts`}
        dataUrl={accountsUrl}
        postUrl={controlExecuteCommandUrl}
      />

      <Tooltip title='View accounts'>
        <span>
          <IconButton size='small' disabled={isDisabled} onClick={openModal}>
            <ManageAccountsIcon/>
          </IconButton>
        </span>
      </Tooltip>
    </>
  )
}

export default React.memo(AccountsModalTrigger)
